import { Theme } from '@material-ui/core/styles';

export const gridItemStyle = (theme: Theme) => ({
  display: 'flex',
});
